import React, { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../components/my-button/MyButton";
import { Circle } from "../../components/Circle";
import MyContext from "../../contexts/MyContext";
export const FormWrapper = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const onBack = () => {
    myContext.changeActiveSlide((myContext.activeSlide -= 1));
  };
  return (
    <Grid container style={{ padding: "1rem" }}>
      <Grid container item xs={12} sm={12} alignItems="center" wrap="nowrap" width={"100%"}>
        <Circle>{props.number}</Circle>
        <h5 style={{ marginTop: "0", marginBottom: "0", marginLeft: "1rem" }}>{props.heading}</h5>
      </Grid>
      <Grid container item xs={12} sm={12} justifyContent="center" width={"100%"}>
        {props.children}
      </Grid>
      <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} width={"100%"}>
        {(props.hasBackButton == null || props.hasBackButton !== false) && (
          <Grid item>
            <MyButton textTransform="none" color="secondary" text={props.backButtonLabel ?? t("back")} onClick={onBack} />
          </Grid>
        )}
        {(props.hasContinueButton == null || props.hasContinueButton !== false) && (
          <Grid item>
            <MyButton textTransform="none" color="secondary" text={props.continueButtonLabel ?? t("continue")} onClick={props.onContinue} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
